export default {
  title: "New password",
  warning: {
    noPassword: "Please fill in your password",
    noMatch: "Your passwords don't match",
    noToken: "Please check your email, your token is missing",
  },
  error: {
    wrongToken: "Please check your email, the token is incorrect",
    passwordEncryption: "Your password could not be encrypted",
  },
  success: {
    passwordChanged: "Password updated, you can now login",
  },

  input: {
    password: {
      label: "Password",
    },
    passwordRepeat: {
      label: "Repeat password",
    },
  },
  button: {
    submit: "Set password",
  },

  api: {
    error: {
      token: {
        invalid: "Please check your email, the token is incorrect",
        isUsed: "Token has already been used, please request a new email",
        expired: "Token is expired, please request a new email",
      }
    }
  }
}
